
/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import { dom as PolymerDom } from '@polymer/polymer/lib/legacy/polymer.dom.js';
/** 
 * This Polymer Element Creates animation in the success page 
 * @customElement
 * @polymer
 * @demo node_modules/speedboat_ui/elements/demo/app-success-animation-demo.html
 * @summary Technical component
*/
const template = html` <style include="app-styles">
.success-icon-container {                
  margin-bottom: -242px;
  margin-top: -20px;
}
.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 50;
  stroke-miterlimit: 10;
  stroke: var(--stroke-color);
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}
#img1{
  max-width: 40%;
  display: block;
  margin-left: auto;
  margin-right: auto; 
  transform: translateY(-74%);                  
}
#img2{
  max-width:70%;
  display: block;
  margin: 0 auto;
  transform: translateY(-149%);
  
}                               
.checkmark {
  max-width: 150px;
  height: 70px;
  border-radius: 50%;
  stroke-width: 2;
  stroke: var(--primary-light-color);
  stroke-miterlimit: 10;
  box-shadow: inset 0px 0px 0px var(--stroke-color);
  animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
  display:block;
  margin:120px auto 0px auto;
  
} 
embed { 
  visibility: hidden;
  height:0px;
  width:0px;
}
.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}
@keyframes stroke {
  100% { stroke-dashoffset: 0; }
}
@keyframes scale {
  0%, 100% { transform: none; }
  50% { transform: scale3d(1.1, 1.1, 1); }
}
@keyframes fill {
  100% { box-shadow: inset 0px 0px 0px 30px var(--stroke-color); }
} 
.success-star-animation, .success-text-animation{
  animation: fadeIn ease 6s;
  -webkit-animation: fadeIn ease 6s;
  -moz-animation: fadeIn ease 6s;
  -o-animation: fadeIn ease 6s;
  -ms-animation: fadeIn ease 6s;
 }
 @keyframes fadeIn{
      0% { opacity:0; }
      100% { opacity:1;}
    }
    @-moz-keyframes fadeIn {
      0% { opacity:0; }
      100% { opacity:1;}
    }
    
    @-webkit-keyframes fadeIn {
      0% { opacity:0; }
      100% { opacity:1;}
    }
    
    @-o-keyframes fadeIn {
      0% { opacity:0; }
      100% { opacity:1;}
    }
    
    @-ms-keyframes fadeIn {
      0% { opacity:0; }
      100% { opacity:1;}
    }  
    .success-rippling-animation {
      animation: fadeOut 3s .2s ease-in forwards;
      -webkit-animation: fadeOut 3s .2s ease-in forwards;
      -moz-animation: fadeOut 3s .2s ease-in forwards;
      -o-animation: fadeOut 3s .2s ease-in forwards;
      -ms-animation: fadeOut 3s .2s ease-in forwards;
    }
    @keyframes fadeOut{
      0%   { opacity: 1; }
      30%  { opacity: 1; }
      50%  { opacity: 1; }
      70%  { opacity: 0; }
      100% { opacity: 0; }
    }
    
    @-moz-keyframes fadeOut {
      0%   { opacity: 1; }
      30%  { opacity: 1; }
      50%  { opacity: 1; }
      70%  { opacity: 0; }
      100% { opacity: 0; }
    }
    
    @-webkit-keyframes fadeOut {
      0%   { opacity: 1; }
      30%  { opacity: 1; }
      50%  { opacity: 1; }
      70%  { opacity: 0; }
      100% { opacity: 0; }
    }
    
    @-o-keyframes fadeOut {
      0%   { opacity: 1; }
      30%  { opacity: 1; }
      50%  { opacity: 1; }
      70%  { opacity: 0; }
      100% { opacity: 0; }
    }
    
    @-ms-keyframes fadeOut {
      0%   { opacity: 1; }
      30%  { opacity: 1; }
      50%  { opacity: 1; }
      70%  { opacity: 0; }
      100% { opacity: 0; }
    }                  
            


</style>

<app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
  <div class="mdl-grid--no-spacing  success-icon-container" hidden$="{{scheduled}}" id="approvalSucessIcon">
      <div class="margin-l-zero mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet text-align-center ">                                    
        <div class="successImg" name="successtick"> 
          <embed autoplay="true" id="successAudo" src="{{imageBaseUrl}}/node_modules/crp_transfer_ui/images/{{tenantId}}/successImages/success.wav">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
            <div class="success-rippling-animation">                             
              <img id="img1" src="{{imageBaseUrl}}/node_modules/crp_transfer_ui/images/{{tenantId}}/successImages/rippling.png" alt="rippling">
            </div>
            <div class="success-star-animation">
              <img id="img2" src="{{imageBaseUrl}}/node_modules/crp_transfer_ui/images/{{tenantId}}/successImages/stars.png" alt="stars" >           
            </div>
        </div>
      </div>
  </div>
  `;

Polymer({
  is: 'app-success-animation',
  _template: template,
  properties: {
    /*Property for the selected tenant Id*/
    tenantId: {
      type: String,
      value: sessionStorage.getItem("tenantId")
    },
    /*Property for the location url of the image to be shown */
    imageBaseUrl: {
      type: String,
      value: window.OEUtils.uibaseroute
    }
  }

});
